import { PropsWithChildren } from 'react'
import { ToastContainer, ToastOptions, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContext } from '../contexts/Toast.context'

const toastOptions: ToastOptions = {
  position: 'top-center',
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
}

const ToastProvider = ({ children }: PropsWithChildren) => {
  const _toast = {
    info: (msg: string) => toast.info(msg, toastOptions),
    success: (msg: string) => toast.success(msg, toastOptions),
    error: (msg: string) => toast.error(msg, toastOptions),
  }

  return (
    <ToastContext.Provider value={{ toast: _toast }}>
      <ToastContainer newestOnTop />
      {children}
    </ToastContext.Provider>
  )
}

export default ToastProvider
